import { gql } from '@apollo/client'

const UPDATE_DIET_SIMPLE_DETAILS_MUTATION = gql`
  mutation updateDietSimpleDetails($id: ID!, $data: DietSimpleDetailsInput!) {
    updateDietSimpleDetails(id: $id, data: $data) {
      id
      description
      updatedAt
      updatedBy {
        id
        name
      }
      position
      isAvailableForDishCategorization
      isExcludedFromSearch
      synonyms
      isPopular
    }
  }
`

export default UPDATE_DIET_SIMPLE_DETAILS_MUTATION
